import React, { useEffect,useState } from 'react';
import './styles.scss';

function ChooseAddressDialog({ initItem, list, onConfirm,
    onCancel, isShow }) {

    const [addressList, setList] = useState(list || []);

    useEffect(() => {
        setList(list || []);
    }, [list]);

  
    const handChooseClick = (item) => {
        //setIsVisible(true);
        if (item) {
            onConfirm(item);
        }
    };

    const handleCancel = () => {
        //setIsVisible(false);
        if (onCancel) {
            onCancel(false);
        }
    };
    
    return (
        <div className="dialog chooseAddress" style={{ display: isShow ? 'flex' : 'none' }}>
            <div className="dialogModel">
                <div className="closeDialog" onClick={() => handleCancel()}></div>
                    
                    <div className="dialogTitle">地址信息</div>
                <div className="dialog-content">
                    <div className="contactList">
                        {
                            addressList.map((item, index) => (
                                <div className={`contactItem address ${item.id == initItem.id?'selected':''}`} key={item.id}
                                    onClick={() => handChooseClick(item)} >
                                    <div className="contactName">
                                        {item.contactName + ' ' + item.mobilePhone}

                                    </div>
                                    <div className="contactDetail"> {
                                        (item.provinceName || '') + ' ' + (item.cityName || '')
                                        + ' ' + (item.districtName || '') + ' ' + item.address + ' '
                                        + item.zipCode
                                    }
                                    </div>
                                </div>
                            ))
                        }
                    </div>                  
                </div>
            </div>
        </div>
    );
};

export default ChooseAddressDialog;